import { Dimensions } from "react-native"

// iOS and web keep laying themselves out with their own safe-area insets; the
// frame only exists on Android (SystemBarsFrame.android.js).

const NO_INSETS = { top: 0, right: 0, bottom: 0, left: 0 }

export const useSystemBarInsets = () => NO_INSETS

export const useWindowHeight = () => Dimensions.get("window").height

export const SystemBarsFrame = ({ children }) => children
